import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'servicedesk-insight-editable-attribute-list.restricted-schema-editing-information.title',
		defaultMessage: 'Inline editing is not available',
		description: 'Explains that inline editing is coming soon for Service objects',
	},
	description: {
		id: 'servicedesk-insight-editable-attribute-list.restricted-schema-editing-information.description',
		defaultMessage: 'Select <bold>Edit</bold> to modify the attributes of this Service.',
		description: 'Instructing user to use edit button to edit attributes on the current service',
	},
	edit: {
		id: 'servicedesk-insight-editable-attribute-list.restricted-schema-editing-information.edit',
		defaultMessage: 'Edit',
		description: 'Button to redirect user to "edit" mode for the current Service object',
	},
});
